<template>
    <div class="table-list lease-finished">
        <contract-release :cid="contractId" :isTool="false" :obj="filterByWord[selectedIndex]"></contract-release>
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <modal class="set-evaluation" :display="modalState.setEvaluation" @modalStatus="closeModal('setEvaluation')" >
            <h1>評價房客</h1>
            <div class="wrap">
                <div class="tenant">
                    <img src="../../../assets/img/icon/user_shot_black.svg" alt="">
                    {{leaseFinishedList.length?leaseFinishedList[selectedIndex].tenantName:''}}
                </div>
                <div class="contract-info">
                    <div>聯絡方式：{{leaseFinishedList.length?leaseFinishedList[selectedIndex].tenantPhone:''}}</div>
                    <div>租期：{{converseDate(leaseFinishedList.length?leaseFinishedList[selectedIndex].contractBeginTime:'')}} - {{converseDate(leaseFinishedList.length?leaseFinishedList[selectedIndex].contractEndTime:'')}}</div>
                    <div>押金：兩個月</div>
                </div>
                <div class="rate-wrap">
                    <span class="title">真實完整敘述，杜絕不良房客</span>
                    <span class="rate" ref="stars">
                        <img @click="setStars(1)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                        <img @click="setStars(2)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                        <img @click="setStars(3)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                        <img @click="setStars(4)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                        <img @click="setStars(5)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                    </span>
                </div>
                <textarea v-model="evaluationParams.comment" name="" id="" cols="30" rows="10"></textarea>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="setEvaluation(), $analytics.logEvent('送出新增評價', { screen_name: '送出新增評價'})">新增</button>
                <button class="border-button reject" @click="closeModal('setEvaluation')">取消</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="contract-date">租約起訖日</span>
            <span class="type">租約類型</span>
            <span class="tanant">租客</span>
            <span class="phone">租客手機</span>
            <span class="address">地址</span>
            <span class="status">結束狀態</span>
            <span class="rent">租金</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-show="filterByWord.length == 0 && leaseFinishedList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-show="leaseFinishedList.length == 0" class="is-empty">0 筆資料</div>
            <ul>
                <li v-for="(house,index) in filterByWord" :key="index">
                    <span class="contract-date">{{converseDate(house.contractBeginTime)}} - {{converseDate(house.contractEndTime)}}</span>
                    <span v-if="house.contractType == 'ELECTRONIC_CONTRACT'" class="type">一般合約</span>
                    <span v-else class="type">紙本合約</span>
                    <span class="tanant">{{house.tenantName}}</span>
                    <span class="phone">{{house.tenantPhone}}</span>
                    <span class="address">{{house.address}}</span>
                    <span class="status">
                         <span class="gray" v-if="house.contractStatus == 'TENANT_FINISHED_CONTRACT'">提前退租</span>
                        <span class="red" v-if="house.contractStatus == 'TENANT_REJECT_CONTRACT' || house.contractStatus == 'TENANT_REJECT_PAPER_CONTRACT' || house.contractStatus == 'TENANT_NOT_CONFIRM_IN_TIME' || house.contractStatus == 'CONTRACT_DEPOSIT_IS_NOT_PAID_IN_TIME'">租客拒絕</span>
                        <span class="red" v-if="house.contractStatus == 'LANDLORD_NOT_CONFIRM_IN_TIME' || house.contractStatus == 'LANDLORD_REJECT_CONTRACT'">房東拒絕</span>
                        <span class="blue" v-if="house.contractStatus == 'CONTRACT_FINISHED'">正常結束</span>
                    </span>
                    <span class="rent">{{toCurrency(house.rentPrice)}}</span>
                    <span class="action">
                        <dot-dropmenu>
                            <ul >
                                <li v-if="house.contractType == 'PAPER_CONTRACT'" @click="getContractPDF(house.contractCid), $analytics.logEvent('查看紙本合約', { screen_name: '查看紙本合約'})">紙本合約</li>
                                <li v-else @click="getContract(house.contractCid), $analytics.logEvent('查看合約', { screen_name: '查看合約'})">查看合約</li>
                                <li v-if="house.isRated == false" @click="setEvaluationClickEvent(index), $analytics.logEvent('新增評價', { screen_name: '新增評價'})" >新增評價</li>
                                <li @click="toBillDetail(house.contractCid), $analytics.logEvent('帳單紀錄', { screen_name: '帳單紀錄'})">帳單紀錄</li>
                                <li @click="contractId = house.contractCid, selectedIndex = index, releaseContract()">退租明細</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import contractRelease from '@/components/widge/modal/contractRelease.vue';

import { mapGetters } from 'vuex'
import { 
    apiGetLeaseFinishedTableList,
    apiGetContract,
    apiGetContractPDF,
    apiGetContractTenant,
    baseDomain,
    apiSetEvaluation
    } from "@/apis/api.js"; 
export default {
    data () {
        return{
            leaseFinishedList: [],
            selectedIndex: 0,
            evaluationParams: {
                "tenantCid" : null,
                "contractCid" : null,
                "rate" : 5,
                "comment" : null
            },
            filterEmpty: false,
            leaseDataEmpty: false,
            leaseDataError: false,
            isLoading: true,
            contractId: null,
            modalState: {
                setEvaluation: false,
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            }
        }
    },
    mounted () {
        this.getLeaseFinishedList()
    },
    methods: {
        setFilterDefault: function () {
            this.$store.dispatch('setFilterDefault')
        },
        getLeaseFinishedList: function () {
            apiGetLeaseFinishedTableList()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    console.log(res)
                    // if( res.data.result.length > 0){
                        this.leaseFinishedList = res.data.result
                        // this.isLoading = false
                    // }else{
                    //     this.leaseDataEmpty = true
                    // }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getContract: function (cid) {
            window.open('/contractPaper?cid='+cid, "_blank")
        },
        getContractPDF: function (cid) {
            apiGetContractPDF(cid)
            .then( res => {
                if(res.status == 200){
                //    window.open(res.data);
                    // var blob = new Blob([res.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf;charset-UTF-8' }));
                    window.open(url);
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        releaseContract: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'contractRelease'})
        },
        toContractDetail: function (cid) {
            window.open('/landlord/leasemanagement/contractdetail?cid='+cid+'&pos=bill')
        },
        closeModal: function (type) {
            this.$store.commit('modalStatus/set_modal_mode', false)
            if( type == 'setEvaluation' ){
                this.modalState.setEvaluation = false
                
            }
        },
        setEvaluation: function (){
            let data = this.evaluationParams
            console.log(data)
            apiSetEvaluation(data)
            .then(res => {
                console.log(res)
                if(res.data.status == "SUCCESS"){
                    this.alart.success = true
                    this.msg.success = '評價成功'
                    this.getLeaseFinishedList()
                }else{
                    this.alart.fail = true
                    this.msg.error = res.data.errorMsg
                }
                this.closeModal('setEvaluation')
            })
            .catch(err => {
                console.log(err)
                this.alart.fail = true
                this.msg.error = err
            })
        },
        setEvaluationClickEvent: function (index) {
            document.getElementsByClassName('lease-management-default')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
            this.selectedIndex = index
            this.modalState.setEvaluation = true
            this.evaluationParams.comment = null
            this.evaluationParams.tenantCid = this.leaseFinishedList[this.selectedIndex].tenantCid
            this.evaluationParams.contractCid = this.leaseFinishedList[this.selectedIndex].contractCid
        },
        setStars: function (rate) {
            // console.log(this.$refs)
            this.evaluationParams.rate = rate
            if(this.$refs.stars.children){
                let stars = this.$refs.stars.children
                for (let i = 1; i < 5; i++) {
                    const star = stars[i];
                    if(i<rate){
                        star.src = require('@/assets/img/component/evaluation/star_golden_large.svg')
                    }else{
                        star.src = require('@/assets/img/component/evaluation/star_gray_large.svg')
                    }
                }
            }
        },
        toBillDetail: function (cid) {
            this.$router.push({ name: 'BillDetail', query: { 'cid': cid }})
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        // getContractTenant: function (cid) {
        //     apiGetContractTenant(cid)
        //     .then(res => {
        //         console.log(res)
        //         if( res.data.status == "SUCCESS" ){
        //         }
        //         // else{
        //         //     this.alart.fail = true
        //         //     this.msg.error = res.data.errorMsg
        //         //     this.errorCode = res.data.errorCode
        //         // }
        //     })
        //     .catch(err => {
        //         console.log(err)
        //     })
        // },
        converseDate: function (date) {
            // console.log(date)
            var formatDate = [];
            var date = new Date(date);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
            //月及天兩位數
            formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            // if(formatDate[3] - 8 < 0){
            //     formatDate[3] = 24+(formatDate[3]-8);
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }else{
            //     formatDate[3] = formatDate[3]-8;
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }
            return formatDate[0]+'-'+formatDate[6]+'-'+formatDate[7]/*' '+formatDate[3]+':'+formatDate[4]+':'+formatDate[5]*/;
        }
        
    },
    computed: {
        // fileterByCounty: function () {
        //     return this.leaseFinishedList.filter((leaseItem) => {
        //         if(this.filterQuery.county){
        //             if(leaseItem.county.includes(this.filterQuery.county) == true){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        // fileterByDistrict: function () {
        //     return this.fileterByCounty.filter((leaseItem) => {
        //         if( this.filterQuery.district){
        //             if(leaseItem.district.includes(this.filterQuery.district) == true){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        // filterByRent: function () {
        //     return this.fileterByDistrict.filter((leaseItem) => {
        //         if( this.filterQuery.rent ){
        //             if( this.filterQuery.rent[0] <= leaseItem.rentPrice && this.filterQuery.rent[1] >= leaseItem.rentPrice ){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        // filterByDesposit: function () {
        //     return this.filterByRent.filter((leaseItem) => {
        //         if( this.filterQuery.desposit ){
        //             if( this.filterQuery.desposit[0] <= leaseItem.rentDeposit && this.filterQuery.desposit[1] >= leaseItem.rentDeposit ){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        // filterByRentDate: function () {
        //     return this.filterByDesposit.filter((leaseItem) => {
        //         if( this.filterQuery.rentDate ){
        //             let rentDate = new Date(leaseItem.billDueTime),
        //                 filterRentDate = Date.parse(this.filterQuery.rentDate).valueOf()

        //             rentDate = rentDate.setHours(rentDate.getHours()-8)
        //             // console.log(rentDate.setHours(rentDate.getHours()-8))
        //             // console.log(filterRentDate)
        //             if( filterRentDate == rentDate ){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        // filterByContractDate: function () {
        //     return this.filterByRentDate.filter((leaseItem) => {
        //         console.log(leaseItem)
        //         if( this.filterQuery.contractDate[0] && this.filterQuery.contractDate[1] ){
        //             let rentDateStart = Date.parse(leaseItem.contractBeganDate).valueOf(),
        //                 rentDateEnd = Date.parse(leaseItem.contractEndTime).valueOf(),
        //                 filterRentDateStart = Date.parse(this.filterQuery.contractDate[0]).valueOf(),
        //                 filterRentDateEnd = Date.parse(this.filterQuery.contractDate[1]).valueOf()
                        
        //             if( filterRentDateStart <= rentDateStart && rentDateEnd <= filterRentDateEnd ){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        // filterByArrears: function () {
        //     return this.filterByContractDate.filter((leaseItem) => {
        //         if( this.filterQuery.arrears){
        //             if(leaseItem.billStatus == this.filterQuery.arrears ){
        //                 return leaseItem
        //             }
        //         }else{
        //             return leaseItem
        //         }
        //     });
        // },
        filterByWord: function () {
            return this.leaseFinishedList.filter((leaseItem) => {
                if( this.filterWord ){
                    if( leaseItem.tenantName.includes(this.filterWord) || leaseItem.address.includes(this.filterWord) || leaseItem.tenantPhone.includes(this.filterWord) ){
                        return leaseItem
                    }
                }else{
                    return leaseItem
                }
            });
        },
        // filterResult: function () {
        //     if( this.leaseDataEmpty == false && this.leaseDataError == false && this.isLoading == false ){
        //         if( this.filterByWord.length == 0 ){
        //             this.filterEmpty = true
        //             this.$store.dispatch('setFilterResultTotal', 0)
        //         }else{
        //             this.filterEmpty = false
        //             this.$store.dispatch('setFilterResultTotal', this.filterByWord.length)
        //             return this.filterByWord
        //         }
        //     }
            
        // },
        ...mapGetters({
            filterWord: 'GET_LEASE_MGT_FILTER_WORD',
            filterQuery: 'GET_LEASE_MGT_FILTER_QUERY',
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        Modal,
        AlartMsg,
        contractRelease
    }
}
</script>
<style lang="scss" scoped>
    .table-list.lease-finished{
        // .table-list-title .contract-date:before{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     top: 2px;
        //     border-style: solid;
        //     border-width: 0 2.5px 4px 2.5px;
        //     border-color: transparent transparent #525956 transparent;
        // }
        // .table-list-title .contract-date:after{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     bottom: 1px;
        //     border-style: solid;
        //     border-width: 4px 2.5px 0 2.5px;
        //     border-color: #525956 transparent transparent transparent;
        // }
            
        .table-list-title .contract-date,
        .table-list-body ul li .contract-date{
            position: relative;
            width: 160px;
            margin-right: 30px;
        }
        .table-list-title .type,
        .table-list-body ul li .type{
            position: relative;
            width: 56px;
            margin-right: 50px;
        }
        .table-list-title .tanant,
        .table-list-body ul li .tanant{
            width: 56px;
            margin-right: 50px;
        }
        .table-list-title .phone,
        .table-list-body ul li .phone{
            width: 78px;
            margin-right: 50px;
        }
        .table-list-title .address,
        .table-list-body ul li .address{
            width: 248px;
            margin-right: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
        }
        .table-list-title .status,
        .table-list-body ul li .status{
            width: 88px;
            margin-right: 50px;
        }
        .table-list-body ul li .status{
            >span{
                width: 88px;
                height: 38px;
                border-radius: 4px;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .gray{
                background-color: #f3f3f3;
                color: #676362;
            }
            .blue{
                background-color: rgba(79, 181, 192, 0.08);
                color: #71aae5;
            }
            .red{
                background-color: rgba(255, 146, 117, 0.1);
                color: #fc7171;
            }
        }
        .table-list-title .rent,
        .table-list-body ul li .rent{
            width: 51px;
            margin-right: 41px;
        }
        .table-list-body ul li .rent{
            text-align: right;
        }
        // .table-list-title .leave-date,
        // .table-list-body ul li .leave-date{
        //     width: 72px;
        //     margin-right: 70px;
        // }
        #modal.set-evaluation{
            .modal-content{
                width: 696px;
                height: 667px;
                padding: 0;
                .detail{
                    >h1{
                        margin-top: 32px;
                        margin-bottom: 50px;
                    }
                    .wrap{
                        width: 632px;
                        margin-bottom: 184px;
                        padding: 0 32px;
                        .tenant{
                            display: flex;
                            align-items: center;
                            font-weight: 500;
                            margin-bottom: 16px;
                            img{
                                margin-right: 8px;
                            }
                        }
                        .contract-info{
                            margin-bottom: 40px;
                            >div{
                                margin-bottom: 8px;
                            }
                        }
                        .rate-wrap{
                            position: relative;
                            margin-bottom: 12px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .title{
                                font-weight: 500;
                            }
                            .rate{
                                >img{
                                    cursor: pointer;
                                }
                            }
                        }
                        textarea{
                            width: 632px;
                            height: 85px;
                            resize: none;
                        }
                    }
                    .btn-group{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 84px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        border-radius:  0 0 20px 20px;
                        margin: 0 auto;
                        button{
                            width: 200px;
                            height: 44px;
                        }
                        button.confirm{
                            margin-right: 16px;
                        }
                    }
                }
                
            }
        }
        
    }
    @media screen and (max-width: 1280px){
        .table-list.lease-finished{
            .table-list-title .contract-date,
            .table-list-body ul li .contract-date{
                margin-right: 30px;
            }
            .table-list-title .type,
            .table-list-body ul li .type{
                margin-right: 47px;
            }
            .table-list-title .tanant,
            .table-list-body ul li .tanant{
                margin-right: 47px;
            }
            .table-list-title .phone,
            .table-list-body ul li .phone{
                margin-right: 47px;
            }
            .table-list-title .address,
            .table-list-body ul li .address{
                margin-right: 47px;
            }
            .table-list-title .status,
            .table-list-body ul li .status{
                margin-right: 47px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/leaseManagement/LeaseFinishedList.vue